



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class MyDialog extends Vue {
  // The title name to display
  @Prop({ required: true }) public title!: string
  // The width of the dialog
  @Prop({ default: '560px' }) public width!: string
  // Show dialog
  @Prop({ default: false }) public visible!: boolean
  // Confirm button loading
  @Prop({ default: false }) public confirmLoading!: boolean
  // Confirm button disabled status
  @Prop({ default: false }) public btnDisabled!: boolean

  private showDialog: boolean = this.visible

  @Watch('visible')
  private onChildChanged(val: boolean, oldVal: boolean) {
    this.showDialog = val
  }

  private confirmClick() {
    // Confirm event
    this.$emit('confirm')
  }
  private open() {
    // Open the dialog event
    this.$emit('open')
  }
  private close() {
    this.$emit('update:visible', false)
    // Close the dialog event
    this.$emit('close')
  }
  private hideDialog() {
    // Hide the Dialog event
    this.$emit('update:visible', false)
  }
  private handleEnterEvent() {
    // Trigger enter event
    this.$emit('keyupEnter')
  }
}
